import { Pagination } from 'packages/core/Pagination';
import { mutations } from './mutations';
import { actions } from './actions';
export var state = {
    formResponses: [],
    loading: false,
    pagination: new Pagination(),
};
export var formResponse = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
